import { render } from "./ViDienTu.vue?vue&type=template&id=1272b984&scoped=true"
import script from "./ViDienTu.vue?vue&type=script&lang=js"
export * from "./ViDienTu.vue?vue&type=script&lang=js"

import "./ViDienTu.vue?vue&type=style&index=0&id=1272b984&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1272b984"]])

export default __exports__